<template>
  <v-container
    fluid
    cols="12"
    class="d-flex"
  >
    <v-layout
      row
      wrap
    >
      <template>
        <v-flex xs12>
          <v-card
            class="ma-2"
          >
            <v-card-title class="toolbar success white--text subheading">
              <span>Details</span>
            </v-card-title>

            <v-card-text>
              <v-layout
                wrap
                class="pa-0"
              >
                <v-flex
                  class="pa-2"
                  xs12
                >
                  <div>
                    User:
                  </div>
                  <UserChip
                    :id="settlement.userId"
                  />
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs12
                >
                  <div>
                    Financial Product:
                  </div>
                  <FinancialProductChip
                    :id="settlement.financialProductId"
                  />
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs12
                >
                  <div>
                    Tranche:
                  </div>
                  <TrancheChip
                    :id="settlement.trancheId"
                  />
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs12
                >
                  <div>
                    Strategy:
                  </div>
                  <StrategyChip
                    :id="settlement.strategyId"
                  />
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs12
                >
                  <div>
                    Mangopay:
                  </div>
                  <MangopayChip
                    :id="settlement.data.strategy.mangoPay.id"
                    :wallet-id="settlement.data.strategy.mangoPay.walletId"
                  />
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs12
                >
                  <v-btn
                    dark
                    flat
                    block
                    color="primary"
                    @click.stop="() => setDebugSettlement(settlement)"
                  >
                    <v-icon
                      class="pr-2"
                    >
                      adb
                    </v-icon>
                    Debug
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </template>
    </v-layout>
    <DebugDialog
      :visible="isDebugDialogActive"
      :debug-object="debugObject"
      :title="debugTitle"
      @close="isDebugDialogActive = false"
    />
  </v-container>
</template>

<script>

import DebugDialog from '@/components/payoutsAndTaxes/payout/dialogs/shared/DebugDialog';
import FinancialProductChip from '@/components/shared/financialProduct/FinancialProductChip';
import StrategyChip from '@/components/shared/digitalDepot/StrategyChip';
import TrancheChip from '@/components/shared/financialProduct/TrancheChip';
import UserChip from '@/components/shared/user/UserChip';
import MangopayChip from '@/components/shared/mangopay/MangopayChip';

export default {
  name: 'SettlementDetails',
  components: {
    DebugDialog,
    FinancialProductChip,
    StrategyChip,
    TrancheChip,
    UserChip,
    MangopayChip,
  },
  props: {
    settlement: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      debugObject: {},
      debugTitle: '',
      isDebugDialogActive: false,
      isHolderDeleteDialogActive: false,
    };
  },
  methods: {
    setDebugSettlement(settlement) {
      this.debugObject = settlement;
      this.debugTitle = 'Debug Settlement Information';
      this.isDebugDialogActive = true;
    },
  },
};
</script>
<style lang="scss" >
.v-data-iterator .v-list__tile{
  height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/settlements/shared/SettlementDetails.vue